// Import Core
import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';
// Import Components
import CardCarouselProduct from '../CardCarouselProduct';
// Import Utils
import getNavItemLinks from '../../../utils/getNavItemLinks';

const TailorMadeHolidaysCardCarousel = ({section}) => {
    return (
      <CardCarouselProduct
        productType='tailorMadeHoliday'
        addToAnchor={section.addToAnchor}
        title={section.sectionTitle.title}
        content={section.sectionTitle.caption}
        linkText={section.navItem && section.navItem.name}
        link={(section.navItem && section.navItem.navItemUrl) && getNavItemLinks(section.navItem)}
        cardList={section.selectedTMHolidays}
      />
    )
}

export default TailorMadeHolidaysCardCarousel